import React, {useEffect, useState} from 'react';
import {IRestaurateur} from "../../../../utils/interfaces/IRestaurateur";
import {useToast} from "../../../../utils/contexts/toast-context";
import {CustomAxiosError} from "../../../../logics/api-config";
import useApiGetRestaurateurs from "../../api-hooks/useApiGetRestaurateurs";
import parser from "../../../../logics/parser";
import Select from "../select/Select";
import Loading from "../Loading";


interface Props {
    restaurateur: IRestaurateur | undefined,
    onChange: (restaurateur: IRestaurateur) => void,
    className: string,
}

const RestaurateurSelect = ({restaurateur: initialRestaurateur, onChange, ...props}: Props) => {
    const {displayError, displayMessage} = useToast()
    const {className = 'text-ref'} = props;
    const [restaurateurs, setRestaurateurs] = useState<IRestaurateur[]>([]);
    const [restaurateur, setSpessore] = useState(initialRestaurateur)

    const {
        data,
        isLoading,
        error,
    } = useApiGetRestaurateurs();
    if (error) {
        const axiosError = error as CustomAxiosError;
        displayError(axiosError.response.data.message);
    }


    useEffect(() => {
        if (data) {
            setRestaurateurs(data);
        }
    }, [data]);


    return (
        isLoading ? (
            <Loading/>
        ) : (

            <Select
                value={restaurateur}
                parseOptions={parser.parseRestaurateurs}
                options={restaurateurs}
                flexDimension={1}
                onChange={onChange}
                placeholder='Filter by Restaurateur'
                selectClassName={className}
            />
        )
    );
}

export default RestaurateurSelect;